export default __webpack_public_path__ + "static/media/digital-organisation.fe51e221.svg";